
import React from 'react';
import { IntlProvider } from 'react-intl';
import { ConfigProvider } from 'antd';
import antdZhCN from 'antd/es/locale/zh_CN';
import antdEnUS from 'antd/es/locale/en_US';
import locale_0 from '/app/src/locales/en-US.ts';
import locale_1 from '/app/src/locales/zh-CN.ts';

const messagesMap = {
  'en-US': locale_0,
  'zh-CN': locale_1,
};

const antdLocaleMap = {
  'zh-CN': antdZhCN,
  'zh': antdZhCN,
  'en-US': antdEnUS,
  'en': antdEnUS,
};

let currentLocale = "zh-CN";
const listeners = new Set();

export function getLocale() {
  return currentLocale;
}

export function setLocale(lang, realReload = true) {
  currentLocale = lang;
  listeners.forEach((fn) => fn(lang));
  if (realReload && typeof window !== 'undefined') {
    window.location.reload();
  }
}

export function getIntl() {
  const messages = messagesMap[currentLocale] || {};
  return {
    locale: currentLocale,
    messages,
    formatMessage({ id }, values) {
      let text = messages[id] != null ? messages[id] : id;
      if (values && typeof text === 'string') {
        Object.keys(values).forEach((k) => {
          text = text.replace(new RegExp('{' + k + '}', 'g'), values[k]);
        });
      }
      return text;
    },
  };
}

export function addLocale(name, messages) {
  messagesMap[name] = { ...(messagesMap[name] || {}), ...messages };
}

export function getAllLocales() {
  return Object.keys(messagesMap);
}

export function rootContainer(container) {
  function LocaleContainer({ children }) {
    const [locale, setLang] = React.useState(currentLocale);
    React.useEffect(() => {
      const handler = (lang) => setLang(lang);
      listeners.add(handler);
      return () => listeners.delete(handler);
    }, []);
    const messages = messagesMap[locale] || {};
    const antdLocale = antdLocaleMap[locale] || antdZhCN;
    // react-intl@3 passes a string to onError (via createError), not { code }.
    // Menu titles use Chinese as ids; missing keys fall back to id — same as umi3 quiet UX.
    const onError = (err) => {
      const msg = typeof err === 'string' ? err : String((err && err.message) || '');
      if (
        msg.includes('Missing message:') ||
        msg.includes('Cannot format message:') ||
        msg.includes('Error formatting message:') ||
        (err && (err.code === 'MISSING_TRANSLATION' || err.code === 'FORMAT_ERROR'))
      ) {
        return;
      }
      if (typeof console !== 'undefined' && console.error && err) {
        console.error(err);
      }
    };
    let child = React.createElement(
      IntlProvider,
      { locale, messages, defaultLocale: locale, onError },
      children,
    );
    child = React.createElement(ConfigProvider, { locale: antdLocale }, child);
    return child;
  }
  return React.createElement(LocaleContainer, null, container);
}
